import React from 'react'
import Layout from '../../../../components/layouts/Layout'

const RoomDetails = () => {
  return (
    <Layout pageTitle={`Room Details`}>RoomDetails</Layout>
  )
}

export default RoomDetails